// import { IResourceComponentsProps } from "@refinedev/core";
// import { MuiEditInferencer } from "@refinedev/inferencer/mui";

// export const ActionEdit: React.FC<IResourceComponentsProps> = () => {
//   return (
//     <MuiEditInferencer
//       fieldTransformer={(field: any) => {
//         if (["locale", "updatedAt", "publishedAt"].includes(field.key)) {
//           return false;
//         }

//         return field;
//       }}
//     />
//   );
// };

import { Box, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useTranslation } from "@refinedev/core";
import { Edit } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { Controller } from "react-hook-form";

export const ActionEdit = () => {
  const { translate } = useTranslation();

  const {
    saveButtonProps,
    register,
    control,
    formState: { errors },
  } = useForm();

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("type", {
            required: translate('this-field-is-required'),
          })}
          error={!!(errors as any)?.type}
          helperText={(errors as any)?.type?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Type"
          name="type"
        />
        <TextField
          {...register("quantity", {
            required: translate('this-field-is-required'),
            valueAsNumber: true,
          })}
          error={!!(errors as any)?.quantity}
          helperText={(errors as any)?.quantity?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Quantity"
          name="quantity"
        />
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box mb={2} mt={5}>
            <Controller
              control={control}
              name="date"
              rules={{ required: translate('this-field-is-required') }}
              // eslint-disable-next-line
              defaultValue={null as any}
              render={({ field }) => (
                <DatePicker
                  label="Day"
                  {...field}
                  value={new Date(field?.value)}
                  onChange={(newValue: any) => {
                    newValue?.setHours(5, 0, 0, 0);
                  }}
                />
              )}
            />
          </Box>
        </LocalizationProvider>
      </Box>
    </Edit>
  );
};
